import React, { useContext, useState } from 'react'
import {
    ArticleLikePublication,
    ConfigurationContext,
    getBaseUrl,
    isLiveSportsTopic,
} from '@news-mono/web-common'
import { appendToHeadline } from '../../../../__helpers/append-to-headline'
import { getEditorialType, getFundingType } from '../../lib'
import { EditorialLabel } from '../../../../typography/EditorialLabel/EditorialLabel'
import { Headline } from '../../../../publication/Headline/Headline'
import { nth } from 'ramda'
import { useSectionMetaInfo } from '../../../../__helpers'
import {
    StyledArticleHeaderContainer,
    StyledDivider,
    StyledTheWestArticleByline,
} from './TheWestArticleHeader.styled'
import { TopicList } from '../../../../content/TopicList/TopicList'
import { TopicV4DTO } from '@west-australian-newspapers/publication-types'

export interface TheWestArticleHeaderProps {
    topics: { primary: TopicV4DTO; secondary: TopicV4DTO[] }
    publication: ArticleLikePublication
}

export const TheWestArticleHeader: React.FC<TheWestArticleHeaderProps> = (
    props,
) => {
    const { publication, topics } = props
    const editorialType = getEditorialType(publication)
    const primaryTopic = publication.primaryTopic.id
    const fundingType = getFundingType(publication)
    const sectionMeta = useSectionMetaInfo()
    const { publicUrl } = useContext(ConfigurationContext)
    const articleUrl = `${getBaseUrl(publicUrl, sectionMeta)}/${primaryTopic}/${
        publication.slug
    }`

    const publicationKind = publication.kind
    const isEvent = publicationKind === 'event'

    const [liveEventUpdated, _] = useState(
        nth(0, isEvent ? publication.entries?.documents : [])?.lastUpdated ??
            publication.lastUpdated,
    )

    return (
        <StyledArticleHeaderContainer>
            <div>
                {/*-- TopicList --*/}
                <TopicList
                    primaryTopic={topics.primary}
                    secondaryTopics={topics.secondary}
                />
                {/*-- EditorialLabel --*/}
                {editorialType && (
                    <EditorialLabel
                        type={editorialType}
                        isLarge
                        kicker={publication.headKicker}
                    />
                )}
            </div>
            {/*-- Headline --*/}
            {editorialType && isLiveSportsTopic(primaryTopic) ? (
                <Headline
                    text={appendToHeadline(publication.heading, editorialType)}
                    className={'thewest-article-headline'}
                />
            ) : (
                <Headline
                    text={publication.heading}
                    className={'thewest-article-headline'}
                />
            )}
            {/*-- Byline --*/}
            <StyledTheWestArticleByline
                text={publication.byline}
                timestampUpdated={isEvent ? liveEventUpdated : undefined}
                timestamp={publication.publicationDate}
                fundingType={fundingType}
                source={publication.source}
                isFullWidth={true}
                url={articleUrl}
                title={publication.heading}
                requiredAccess={publication.requiredAccess}
                allowCommenting={publication.allowCommenting}
                publicationKind={publication.kind}
                noLine={true}
            />
            {/*-- Divider --*/}
            <StyledDivider />
        </StyledArticleHeaderContainer>
    )
}
